/**
 * 全局有遮罩的 Loading 组件管理
 * 基于 van-overlay + 自定义 Loading 组件，支持遮罩层
 */

import { createApp, type App as VueApp } from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import AppLoadingOverlay from '@/components/feedback/AppLoadingOverlay.vue'

let app: VueApp | null = null
let overlayComponent: InstanceType<typeof AppLoadingOverlay> | null = null
let container: HTMLElement | null = null

const mountOverlay = () => {
  if (app) return

  container = document.createElement('div')
  container.setAttribute('id', 'app-loading-overlay-root')
  document.body.appendChild(container)

  app = createApp(AppLoadingOverlay)
  app.use(Vant)
  overlayComponent = app.mount(container) as InstanceType<typeof AppLoadingOverlay>
}

const unmountOverlay = () => {
  if (app) {
    app.unmount()
    app = null
    overlayComponent = null
  }
  if (container) {
    document.body.removeChild(container)
    container = null
  }
}

export const showLoadingOverlay = (message: string = '') => {
  mountOverlay()
  overlayComponent?.show(message)
}

export const closeLoadingOverlay = () => {
  overlayComponent?.hide()
  setTimeout(() => {
    unmountOverlay()
  }, 300)
}
